import {
  GET_DROPZZ_VERIFICATIONS,
  GET_DROPZZ_VERIFICATION_ITEM,
  SET_DROPZZ_VERIFICATION_PAGE,
  SET_DROPZZ_VERIFICATION_STATUS,
} from '../../shared/constants/ActionTypes';

const initialState = {
  items: [],
  total: 0,
  page: 1,
  status: '',
  currentItem: null,
};

const dropzzVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DROPZZ_VERIFICATIONS:
      return {
        ...state,
        items: action.payload.data,
        total: action.payload.total,
      };
    case GET_DROPZZ_VERIFICATION_ITEM:
      return {
        ...state,
        currentItem: action.payload,
      };
    case SET_DROPZZ_VERIFICATION_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_DROPZZ_VERIFICATION_STATUS:
      return {
        ...state,
        status: action.payload,
        page: 1,
      };
    default:
      return state;
  }
};

export default dropzzVerificationReducer;
